module.exports = __webpack_public_path__ + "static/media/stanford.2bcd326e.png";